import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';
import type { Comic } from '@/mocks/comics';

export function getCategoryName(id: string | undefined): string {
  if (!id) {
    return '全部漫画';
  }
  const found = categories.find((c) => c.id === id);
  return found ? found.name : '全部漫画';
}

export function getComicById(id: string | undefined): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(catId: string | undefined): Comic[] {
  if (!catId || catId === 'all') {
    return comics;
  }
  return comics.filter((c) => c.categories.includes(catId));
}

export function getRelatedComics(comic: Comic, limit = 4): Comic[] {
  const same = comics.filter(
    (c) =>
      c.id !== comic.id &&
      c.categories.some((cat) => comic.categories.includes(cat)),
  );
  if (same.length >= limit) {
    return same.slice(0, limit);
  }
  const others = comics.filter(
    (c) =>
      c.id !== comic.id &&
      !c.categories.some((cat) => comic.categories.includes(cat)),
  );
  return [...same, ...others].slice(0, limit);
}